<!--
 * @Description: 用于展示editor组件的v-html内容
 * @Author: 李丁丁
 -->
<template>
  <div class="sy-editor-show ql-container ql-snow">
    <div class="ql-editor" v-html="DOMPurify.sanitize(value || editorData)"></div>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import createDOMPurify from 'dompurify'
const DOMPurify = createDOMPurify(window)

export default {
  name: 'sy-editor-show',
  props: ['editorData', 'value'], // editorData 被废弃，由value取代
  data () {
    return {
      DOMPurify
    }
  }
}
</script>

<style scoped>
  .sy-editor-show.ql-container.ql-snow {
    border: none;
  }
  .sy-editor-show ::v-deep .ql-editor em {
    font-style: italic;
  }
</style>
